import { EditPronounsService } from '../services/edit_pronouns_service';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { PronounsQuery } from 'capability-ng-priority-feed';
import { PronounsListQuery } from '../queries/pronouns_list_query';
import { AccountModel } from 'data-ng-authentication';
import { NO_PRONOUNS_STRING } from '../main';

export class EditPronounsModalController {
  private studentPronouns = NO_PRONOUNS_STRING;
  private showInputBox = false;
  private pronounsPattern: string = '[a-zA-Z]+/[a-zA-Z]+';
  private pronounsList: any;
  private newStudentPronoun: string;
  private showPronounsInvalidError = false;
  constructor(
    private ngEditPronounsService: EditPronounsService,
    private ngPronounsQuery: PronounsQuery,
    private ngPronounsListQuery: PronounsListQuery,
    private editPronounsCommand: ICommand,
    private accountModel: AccountModel,
    private $state: ng.ui.IStateService
  ) {
    this.studentPronouns = _4.get(this.ngPronounsQuery.result, 'selected_pronouns');
  }
  $onInit(): void {
    this.pronounsList = this.ngPronounsListQuery.result;
  }

  toggleInputBox(event: any) {
    this.newStudentPronoun = event.originalEvent.detail.value;
    this.showInputBox = this.newStudentPronoun === 'custom';
  }

  validatePronouns(event: any) {
    this.newStudentPronoun = event.originalEvent.detail.value;
    if (this.newStudentPronoun && this.newStudentPronoun.length > 0) {
      this.showPronounsInvalidError =
        this.newStudentPronoun.indexOf('/') === -1 ||
        this.newStudentPronoun.indexOf('/') === this.newStudentPronoun.length - 1 ||
        this.newStudentPronoun.indexOf('<') !== -1 ||
        this.newStudentPronoun.indexOf('>') !== -1;
    }
  }

  isDesktop() {
    return PlatformUtility.isDesktop();
  }

  finishAndExit() {
    this.ngEditPronounsService.toggleOpen(false);
  }

  updatePronouns() {
    if (this.showPronounsInvalidError) {
      return;
    }
    this.editPronounsCommand(_4.get(this.accountModel, 'student_nk', ''), this.newStudentPronoun)
      .then(() => {
        this.finishAndExit();
      })
      .catch(() => {
        this.finishAndExit();
      });
  }
}
export class EditPronounsModalComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-settings/src/modals/edit_pronouns.html';
  public controller: any = EditPronounsModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/modals/edit_pronouns.ts